import { List } from 'immutable';
import { shouldUseAutoJoin } from './join-select-utils';
import { Column } from '../schema/column-records';
import { createMagicMeasure, getColumnLabel, getIconFromColumn } from './column-utils';
import { getTableLabelWithSelfJoins, getTableList } from './table-utils';
import { isNotNull } from '../../shared/lib/utility-types';
export const defaultMagicMeasure = {
  text: '',
  value: Column({
    role: '',
    domain: '',
    field: {
      name: '',
      type: ''
    },
    alias: ''
  }),
  icon: '',
  sourceLabel: '',
  objectTypeId: '',
  tableName: '',
  isDefault: true
};
export const getDefaultPropertyData = ({
  tableDescription,
  properties,
  tables,
  allJoinMetadata
}) => {
  if (!shouldUseAutoJoin(tableDescription)) {
    return {
      shouldUseAutoJoin: false,
      magicMeasures: List([defaultMagicMeasure])
    };
  }
  const magicMeasures = List(getTableList(tableDescription).map(createMagicMeasure).toArray().filter(isNotNull));
  return {
    shouldUseAutoJoin: true,
    magicMeasures: magicMeasures.map(column => {
      const {
        field
      } = column;
      const {
        name: fieldName,
        table
      } = field;
      const tableName = table || '';
      const snowflakeTable = tables.get(tableName);
      if (!snowflakeTable) {
        return Object.assign({}, defaultMagicMeasure, {
          tableName
        });
      }
      const snowflakeProperty = properties.getIn([tableName, fieldName]);
      const text = getColumnLabel(column, snowflakeProperty, snowflakeTable, undefined, List(), tableDescription, allJoinMetadata);
      const icon = getIconFromColumn(column);
      const sourceLabel = getTableLabelWithSelfJoins(tableName, tableDescription, snowflakeTable, allJoinMetadata);
      return {
        text,
        value: column,
        icon,
        sourceLabel,
        objectTypeId: snowflakeTable.get('objectTypeId', '')
      };
    }).toList()
  };
};